import { useEffect } from 'react';
import { pushRBoxListener } from '../utils';

export const addRBoxListener = (type, callback) => {
    pushRBoxListener(type, callback);
};

export const useRBoxListenerEffect = (type, callback) => {
    useEffect(() => {
        addRBoxListener(type, callback);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type]);
};
